module.exports = __webpack_public_path__ + "img/penjualan.79bed8ad.jpg";